import { render, staticRenderFns } from "./BannerClientAreas.vue?vue&type=template&id=54a66321&scoped=true"
import script from "./BannerClientAreas.vue?vue&type=script&lang=js"
export * from "./BannerClientAreas.vue?vue&type=script&lang=js"
import style0 from "./BannerClientAreas.vue?vue&type=style&index=0&id=54a66321&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a66321",
  null
  
)

export default component.exports